// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

export const AutoCompleteUL = styled.ul`
  background-color: white;
  padding: 0;
  list-style-type: none;
  border: 1px solid
    ${(props) =>
      props.spc ? props.theme.colorPalette.blue[800] : props.theme.colors.PRIMARY.LIGHTPALEGRAY};
  border-radius: ${(props) =>
    props.spc
      ? `0px 0px  ${props.theme.spacing.ELEM_SPACING.XS_6} ${props.theme.spacing.ELEM_SPACING.XS_6}`
      : '0'};
  ${(props) =>
    props.spc
      ? `
    border-color: ${
      !((props.meta?.touched && props.meta?.error) || props.showExplicitError)
        ? props.theme.colorPalette.blue[800]
        : props.theme.colorPalette.red[500]
    };
  `
      : ''}
  border-top: 0;
  box-sizing: border-box;
  position: absolute;
  z-index: 1000;
  margin-top: -12px;
  ${(props) => (props.spc ? 'margin-right: -2px;' : '')}
  ${(props) => `width:${props.inputElem.offsetWidth}px`};
  ${(props) => {
    let display = `display:none`;
    if (props.isAutoSuggestOpen) {
      display = `display:block`;
    }
    return display;
  }};

  &:after {
    content: '';
    padding: 1px 1px 1px 0;
    height: ${(props) => (props.spc ? '0px' : '18px')};
    box-sizing: border-box;
    text-align: right;
    display: block;
    background-position: right;
    background-repeat: no-repeat;
    background-size: 120px 14px;
  }

  .default-li {
    display: ${(props) => (props.spc ? 'flex' : 'none')};
    padding-bottom: 0px;
  }
`;

export const AutoCompleteLi = styled.li`
  padding: 5px 5px 5px 10px;
  height: 26px;
  line-height: 26px;
  border-top: ${(props) =>
    !props.spc ? `1px solid ${props.theme.colors.PRIMARY.LIGHTERGRAY};` : '0'};
  position: relative;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: ${(props) =>
    props.spc ? props.theme.fonts.fontSize.textbox_input : props.theme.fonts.fontSize.textbox}px;
  font-family: ${(props) => (props.theme.brand === 'tcp' ? `Tofino` : `Nunito`)};
  display: flex;
  align-items: center;

  ${(props) =>
    props.spc
      ? `
    padding: ${props.theme.spacing.ELEM_SPACING.SM} ${props.theme.spacing.ELEM_SPACING.MED} ${props.theme.spacing.ELEM_SPACING.SM} ${props.theme.spacing.ELEM_SPACING.MED};

    @media ${props.theme.mediaQuery.medium} {
      padding: 18px ${props.theme.spacing.ELEM_SPACING.MED} 18px ${props.theme.spacing.ELEM_SPACING.MED};
    }
  `
      : ''}

  .autocomplete-text {
    line-height: 0.88;
    letter-spacing: 0.23px;
    padding: ${(props) =>
      props.spc
        ? `0px 0px ${props.theme.spacing.ELEM_SPACING.XXS} 0px`
        : `${props.theme.spacing.ELEM_SPACING.XXS} ${props.theme.spacing.ELEM_SPACING.XXS} 0px 0px`};
    font-size: ${(props) => `${props.theme.fonts.fontSize.body.bodytext.copy2}px`};

    @media ${(props) => props.theme.mediaQuery.medium} {
      font-size: ${(props) => `${props.theme.fonts.fontSize.body.bodytext.copy4}px`};
    }

    text-overflow: ellipsis;
    overflow: hidden;
  }

  &:hover {
    ${(props) =>
      props.spc
        ? `
        background: ${props.theme.colors.BUTTON.WHITE.HOVER};
    `
        : `font-weight: 'bold';`}
  }
`;

export const SpanIcon = styled.span`
  display: inline-block;
  height: 18px;
  width: 15px;
  background-size: 31px;
  margin-right: 5px;
  background-image: url(https://maps.gstatic.com/mapfiles/api-3/images/autocomplete-icons_hdpi.png);
  background-position: -1px -161px;
`;

export const SeparatorLi = styled.li`
  padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
`;

export const SeparatorDiv = styled.div`
  margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
  border-top: 1px solid;
  border-color: ${(props) =>
    !props.isErrored ? props.theme.colorPalette.blue[800] : props.theme.colorPalette.red[500]};
`;
